import { reactive } from "@vue/composition-api";
import { buildFormLineItemAutocomplete } from "@/models/LineItem";
import { AutocompleteResult } from "@/components/Autocomplete/autocomplete-id";

export interface TruckLoadLineItemApiParams {
  id?: string;
  item_date: string;
  rate: number;
  quantity: number;
  sort_order: number;
  line_item_id: string;
  quantity_sync: string;
  truck_load_id?: string;

  _destroy: boolean;
}

export interface TruckLoadLineItem {
  id: string;
  item_date: string;
  rate: number;
  quantity: number;
  sort_order: number;
  line_item_id: string;
  quantity_sync: string;
  truck_load_id: string;

  truck_load_completed_date: string;
  truck_load_label: string;
  line_item_label: string;
}

export interface FormTruckLoadLineItem extends TruckLoadLineItemApiParams {
  formLineItem: AutocompleteResult;
}

export function buildNewTruckLoadLineItem(): TruckLoadLineItem {
  return {
    id: "",
    item_date: "",
    rate: 0,
    quantity: 0,
    sort_order: 200,
    line_item_id: "",
    quantity_sync: "none",
    truck_load_id: "",
    truck_load_completed_date: "",

    truck_load_label: "",
    line_item_label: "",
  };
}

export function buildFormTruckLoadLineItems() {
  let { formLineItem } = buildFormLineItemAutocomplete();
  let formTruckLoadLineItems = reactive<FormTruckLoadLineItem[]>([]);

  let addTruckLoadLineItem = (lnItems: FormTruckLoadLineItem[]) => {
    lnItems.push({
      id: "",
      item_date: "",
      rate: 0,
      quantity: 0,
      sort_order: 200,
      line_item_id: "",
      quantity_sync: "none",
      truck_load_id: "",

      formLineItem: formLineItem(),

      _destroy: false,
    });
  };

  let loadTruckLoadLineItemIntoForm = (
    ln: TruckLoadLineItem,
    fln: FormTruckLoadLineItem,
  ) => {
    fln.id = ln.id;
    fln.item_date = ln.item_date;
    fln.rate = ln.rate;
    fln.quantity = ln.quantity;
    fln.sort_order = ln.sort_order;
    fln.line_item_id = ln.line_item_id;
    fln.quantity_sync = ln.quantity_sync;
    fln.truck_load_id = ln.truck_load_id;

    fln.formLineItem.id = ln.line_item_id;
    fln.formLineItem.label = ln.line_item_label;
  };

  let loadTruckLoadLineItemsIntoForm = (
    lns: TruckLoadLineItem[],
    flns: FormTruckLoadLineItem[],
  ) => {
    for (const l of lns) {
      addTruckLoadLineItem(flns);
      loadTruckLoadLineItemIntoForm(l, flns[flns.length - 1]);
    }
  };

  return {
    addTruckLoadLineItem,
    formTruckLoadLineItems,
    loadTruckLoadLineItemIntoForm,
    loadTruckLoadLineItemsIntoForm,
  };
}
